const initialStateReportFilter = {
  userId: null,
  favorites: false,
};

export { initialStateReportFilter };
